<template>
  <div>
    <div class="container wow fadeInUp" v-if="infoNewsChild.length != 0">
      <h2>INFORMATION<span>インフォメーション</span></h2>
      <div class="news__list">
        <fragment v-for="(item, index) in infoNewsChild" :key="index">
          <div class="news" v-if="index <= 2">
            <router-link :to="'/information/' + item.id">
              <span class="news__date">{{formatDate(item.acf.start_date)}}</span>
              <span class="news__title">{{item.acf.title}}</span>
            </router-link>
          </div>
        </fragment>
        
        <div class="news__link">
          <router-link class="btn_link" to="/information">もっと見る</router-link>
        </div>
      </div>
    </div>
    <div class="container wow fadeInUp" v-else>
      <h2>INFORMATION<span>インフォメーション</span></h2>
      <div class="no-data info-custom">
        <div class="text-notification">現在、ご案内する情報はありません</div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import axios from "axios";
  import { Fragment } from "vue-fragment";

  export default {
    name: "InfomationNewsList",
    props: {
      infoNewsChild: {
        type: Array,
      },
    },
    data() {
      return {
        // infomationNews: [],
        // isLoading: true,
      };
    },
    components: {
      Fragment
    },

    computed: {
    },

    methods: {
      formatDate(info) {
        return moment(info.replaceAll('/', '-')).format("YYYY.MM.DD");
      },
    },
    created() {
      // this.isLoading = true
      // const informationUrl = process.env.VUE_APP_BASE_URL + "/information?acf_format=standard&_fields=id,acf";
      // axios
      //   .get(
      //     informationUrl, {
      //     headers: {
      //       Authorization: `Basic ${process.env.VUE_APP_BASE_TOKEN}`
      //     }
      //   })
      //   .then((response) => {
      //     this.infomationNews = response.data;
      //     this.isLoading = false;
      //   })
      //   .catch((e) => {
      //     console.log(e);
      //   });
    },
  };
</script>